module.exports = __webpack_public_path__ + "teqbahn-assets/media/5.2af6660f.jpg";